import { Injectable } from '@angular/core';
import { RtmClient } from 'agora-rtm-sdk';
import AgoraRTM from 'agora-rtm-sdk';

@Injectable({
  providedIn: 'root'
})
export class AgoraRtmService {

  constructor() { }

  private clientRtm: RtmClient;
  channels = {}

  async joinChannel (client:RtmClient, name) {
    console.log('joinChannel', name)
    const channel = client.createChannel(name)
    this.channels[name] = {
      channel
    }
    return channel.join()
  }

  async sendChannelMessage (text, channelName) {
    if (!this.channels[channelName]) return
    return this.channels[channelName].channel.sendMessage({ text })
  }

  initAgoraClients(localCallId, meetingId){
    this.clientRtm = AgoraRTM.createInstance("5a3f5b28fb3642668022ce476f1f3996");
    return this.clientRtm.login({uid: localCallId}).then(r => {
      return this.joinChannel(this.clientRtm, meetingId);
    })
  }

  logoutRtmClient(meetingId){
    this.clientRtm.logout();
  }

}
